import {
  convertLabelMapToConfig,
  convertLabelUomMapToConfig,
  mergeConfig,
} from 'Components/Worksheets/Core/Helpers/configHelpers';

const getLabelConfig = (prefix: string) =>
  mergeConfig(
    convertLabelMapToConfig({
      [`${prefix}.Preparation.DropHeight`]: `Drop Height`,
      [`${prefix}.Preparation.SamplePreparationMethod`]: `Sample Preparation`,
      [`${prefix}.Preparation.TestLocation`]: `Test Location`,
      [`${prefix}.Preparation.Oven`]: `Oven`,
      [`${prefix}.Preparation.Balance`]: `Balance`,
      [`${prefix}.Preparation.Sieve`]: `20mm Sieve Used`,
      [`${prefix}.Preparation.BalanceIsSuitableForUse`]: `Balance is suitable for use`,
      [`${prefix}.Preparation.NoOversizeMaterial`]: `No Oversize Material`,

      [`${prefix}.Preparation.TareMass`]: `Tare Mass`,
      [`${prefix}.Preparation.TareAndTotalSampleMass`]: `Tare and Total Sample Mass`,
      [`${prefix}.Preparation.TotalSampleMass`]: `Total Sample Mass`,
      [`${prefix}.Preparation.MassRetainedOn20_0mmSieve`]: `Mass Retained on 20mm Sieve`,
      [`${prefix}.Preparation.MassRetainedOn20_0mmSievePercentage`]: `Retained on 20mm Sieve by Wet Mass`,
      [`${prefix}.Preparation.TestPortionMass`]: `Test Portion Mass`,
      [`${prefix}.Preparation.TotalSampleDryMass`]: `Total Sample Dry Mass`,
      [`${prefix}.Preparation.DryMassRetainedOn20_0mmSievePercentage`]: `Retained on 20mm Sieve by Dry Mass`,
      [`${prefix}.Preparation.DryMassRetainedOn20_0mmSievePercentage`]: `Retained on 20mm Sieve by Dry Mass`,
      [`${prefix}.Preparation.StabiliserUsed`]: `Stabilized Material`,
      [`${prefix}.Preparation.StabiliserType`]: `Stabilizer Type`,
      [`${prefix}.Preparation.StabiliserAmount`]: `Stabilizer Amount`,

      [`${prefix}.Measurements.MCVApparatus`]: `MCV Apparatus`,
      [`${prefix}.Measurements.Mould`]: `Mould`,
      [`${prefix}.Measurements.Calliper`]: `Calliper`,
      [`${prefix}.Measurements.DropHeightChecked`]: `Drop height checked`,

      [`${prefix}.Results.InterpretationMethod`]: `Interpretation Method`,
      [`${prefix}.Results.WaterContentPercent`]: `Water Content`,
      [`${prefix}.Results.MoistureConditionValueText`]: `Moisture Condition Value`,
    }),
    convertLabelUomMapToConfig({
      [`${prefix}.Preparation.MassRetainedOn20_0mmSievePercentage`]: '%',
      [`${prefix}.Preparation.DryMassRetainedOn20_0mmSievePercentage`]: '%',
      [`${prefix}.Results.WaterContentPercent`]: '%',
      [`${prefix}.Preparation.StabiliserAmount`]: '%',
    })
  );

export default getLabelConfig;
